import { container } from "tsyringe";
import { SiteSettings } from "../shared/SiteSettings";
import { ToutvSiteSettings } from "./ToutvSiteSettings";
import { ServiceTokens } from "../shared/ServiceTokens";
import { LotameConfig } from "../lotame/LotameConfig";
import { PageAttributesExtractor } from "../shared/PageAttributesExtractor";
import { UserDataLayerAdapterFactory } from "../shared/UserDataLayerAdapterFactory";
import { ToutvUserDataLayerAdapterFactory } from "./ToutvUserDataLayerAdapterFactory";
import { ToutvPageAttributesExtractor } from "./ToutvPageAttributesExtractor";
import { SiteRules } from "../shared/SiteRules";
import { ToutvSiteRules } from "./ToutvSiteRules";
import { GeoIpCoordinatesService } from "../shared/geoLocation/GeoIpCoordinatesService";
import { ToutvGeoCoordinatesService } from "./ToutvGeoCoordinatesService";

/**
 * This function is used to register Toutv-specific implementations to
 * TSyringe's container.
 */
export function registerToutvServices(): void {
  container.register<GeoIpCoordinatesService>(ServiceTokens.GeoCoordinatesService, {
    useClass: ToutvGeoCoordinatesService,
  });
  container.register<LotameConfig>(LotameConfig, {
    useValue: new LotameConfig("17099", "lotame_17099_auds"),
  });
  container.register<SiteSettings>(ServiceTokens.SiteSettings, {
    useClass: ToutvSiteSettings,
  });
  container.register<PageAttributesExtractor>(ServiceTokens.PageAttributesExtractor, {
    useClass: ToutvPageAttributesExtractor,
  });
  container.register<SiteRules>(SiteRules, {
    useValue: new ToutvSiteRules(),
  });
  container.register<UserDataLayerAdapterFactory>(ServiceTokens.UserDataLayerAdapterFactory, {
    useClass: ToutvUserDataLayerAdapterFactory,
  });
}
